<script>
export default {
  props: {
    // Placeholder title
    title: {
      type: String,
      default: ''
    },
    // Placeholder subtitle
    subtitle: {
      type: String,
      default: ''
    }
  }
}

</script>

<template>
  <main class="accounts-view">
    <header class="accounts-header row items-center justify-center" v-if="title">
      <slot name="header">
        <div class="artup-logo q-mr-md">
        </div>
        <span class="text">
          {{ title }}
        </span>
      </slot>
    </header>

    <header class="accounts-subheader row items-center justify-center q-mt-lg" v-if="subtitle">
      <slot name="subheader">
        <span class="text">
          {{ subtitle }}
        </span>
      </slot>
    </header>

    <section class="accounts-content">
      <slot name="content">
      </slot>
    </section>

    <footer class="column items-center justify-center">
      <slot name="footer">
      </slot>
    </footer>
  </main>
</template>

<style lang="scss">
.accounts-view {
  flex: 1;
  width: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-content: safe center;
  padding: 20px;

  label,
  span,
  p,
  button,
  a {
    font-size: 16px;
  }

  a {
    text-decoration: none;
    color: #004da4;
    cursor: pointer;

    &:not(.q-btn):hover {
      color: #0077ff;
      text-decoration: underline;
    }
  }

  .accounts-header,
  &>header:nth-child(1) {
    .artup-logo {
      width: 60px;
      height: 60px;
    }

    .text {
      font-size: 44px;
      font-weight: bold;
      text-align: center;
    }
  }

  .accounts-subheader,
  &>header:nth-child(2) {
    .artup-logo {
      width: 60px;
      height: 60px;
    }

    .text {
      font-size: 22px;
      font-weight: bold;
      text-align: center;
    }
  }

  >section,
  .accounts-content {
    display: flex;
    flex-direction: column;

    form.form,
    div.form {
      width: 50vw;
      max-width: 500px;
      padding: 20px;

      &.wider {
        max-width: 600px;
      }

      .fields {
        display: flex;
        flex-direction: column;


        &.items-center {

          label,
          span,
          p,
          button,
          a {
            text-align: center;
          }
        }
      }

      .buttons {
        display: flex;
        flex-direction: column;
      }
    }

  }

  >footer {
    position: fixed;
    bottom: 8px;
    height: 70px;
  }
}

/* Layout adjustments for mobile screens */
@media screen and (max-width: 640px) {
  .accounts-view {
    align-items: center;
    justify-content: flex-start;
    padding: 24px 16px 48px 16px;

    label,
    span,
    p,
    button,
    a {
      font-size: 15px;
    }

    .accounts-header,
    &>header:nth-child(1) {
      .artup-logo {
        display: none !important;
      }

      .text {
        font-size: 26px;
        text-align: center;
      }
    }

    .accounts-subheader,
    &>header:nth-child(2) {
      display: none !important;
    }

    >section,
    .accounts-content {
      width: 100%;
      margin-top: 16px;

      form.form,
      div.form {
        width: 100%;
        max-width: 100%;
        padding: 8px 12px;

        &.wider {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
